import * as React from 'react';

interface Props {
  style?: {};
  alt: string;
  image?: File;
  defaultImagePath: string;
  className?: string;
}

const FileImage: React.StatelessComponent<Props> = (props: Props) => (
  <img
    className={props.className || ''}
    style={props.style || {}}
    alt={props.alt}
    /* tslint:disable no-any */
    src={props.image ?
      (window.URL || (window as any).webkitURL).createObjectURL(props.image) :
      props.defaultImagePath
    }
  /* tslint:enable no-any */
  />
);

export default FileImage;



// WEBPACK FOOTER //
// ./src/modules/commons/images/FileImage.component.tsx